import React, { useEffect } from "react";
import { Provider } from "react-redux";
import { ConnectedRouter } from "connected-react-router";
import { Route, Switch } from "react-router-dom";
import "assets/vendors/style";
import "styles/wieldy.less";
import configureStore, { history } from "./appRedux/store";
// import "./firebase/firebase";
import App from "./containers/App/index";
import { XMPPProvider } from "./providers/XMPPProvider";
import { injectStoreToXMPPService } from "./chatServices/XMPPservice";
import { injectStoreToAPI } from "./api/api";

const store = configureStore();
// console.log(store, 'sssssssssssssssstoreeeeeeeeeeeeee')
const NextApp = () => {
  // console.log('sssssssssssssssstoreeeeeeeeeeeeee')

  useEffect(() => {
    injectStoreToAPI(store);
    injectStoreToXMPPService(store);
  }, [store]);

  return (
    <Provider store={store}>
      <ConnectedRouter history={history}>
        <XMPPProvider>
          <Switch>
            <Route path="/" component={App} />
          </Switch>
        </XMPPProvider>
      </ConnectedRouter>
    </Provider>
  );
};

export default NextApp;
